// Friendly labels for the fixed onboarding goal slugs (matches the APIv2 seed).
export const GOAL_LABELS = {
  anxiety_stress: 'Anxiety & Stress',
  better_sleep: 'Better Sleep',
  pain_relief: 'Pain Relief',
  motivation_productivity: 'Motivation & Productivity',
  fear_worry: 'Fear & Worry',
  general: 'General (fallback)',
};

export function goalLabel(slug) {
  return GOAL_LABELS[slug] || slug;
}
